"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AemConfigurationContextWrapper = exports.useAemConfig = exports.AemConfigurationContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AemConfigurationUtils_1 = require("./AemConfigurationUtils");
exports.AemConfigurationContext = (0, react_1.createContext)({});
const useAemConfig = () => (0, react_1.useContext)(exports.AemConfigurationContext);
exports.useAemConfig = useAemConfig;
const AemConfigurationContextWrapper = ({ children, value }) => ((0, jsx_runtime_1.jsx)(exports.AemConfigurationContext.Provider, { value: (0, AemConfigurationUtils_1.generateAemConfiguration)(value), children: children }));
exports.AemConfigurationContextWrapper = AemConfigurationContextWrapper;
//# sourceMappingURL=AemConfigurationContext.js.map